import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title" }, "Anything not right?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " After reviewing the summary, if there is anything you need to correct, please enter details in the box below. "),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " Please note that by entering any text into the box, the application process will be delayed, as our underwriter will need to correct and review the application. "),
  /*#__PURE__*/_createElementVNode("p", null, " By leaving the free text box blank, you are confirming that all information reflecting the summary is accurate. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}